import React from 'react';

import { Dialog, IconButton, Button } from '@material-ui/core';

import CloseIcon from '@mui/icons-material/Close';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import InsightsIcon from '@mui/icons-material/Insights';
import RouteIcon from '@mui/icons-material/Route';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import GavelIcon from '@mui/icons-material/Gavel';
import HubIcon from '@mui/icons-material/Hub';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

import PropTypes from 'prop-types';

const WHATSAPP_COMERCIAL = '554884220475';

const MENSAGEM_WHATSAPP =
  'Olá! Tenho interesse em migrar minha conta para o Plano PRÓ do CobCloud.';

const FUNCIONALIDADES = [
  {
    icon: <PhoneInTalkIcon />,
    titulo: 'Integração com discadores',
    descricao:
      'Conecte sua operação aos principais discadores e ganhe produtividade nas ligações.',
  },
  {
    icon: <EmojiEventsIcon />,
    titulo: 'Gestão de metas',
    descricao:
      'Defina e acompanhe metas da empresa e de cada colaborador em um só lugar.',
  },
  {
    icon: <TrackChangesIcon />,
    titulo: 'Indicador de meta no dashboard',
    descricao:
      'Cada colaborador enxerga o próprio desempenho em tempo real no dashboard.',
  },
  {
    icon: <FormatListNumberedIcon />,
    titulo: 'Filas de cobrança',
    descricao:
      'Distribua a carteira de forma inteligente e priorize quem realmente deve ser acionado.',
  },
  {
    icon: <InsightsIcon />,
    titulo: 'BI / Dashboards',
    descricao:
      'Painéis analíticos completos para decidir com base em dados, não em achismo.',
  },
  {
    icon: <RouteIcon />,
    titulo: 'Régua de cobrança',
    descricao:
      'Automatize a jornada de contato do devedor do início ao fim da negociação.',
  },
  {
    icon: <AutoModeIcon />,
    titulo: 'Quebra de acordo automática',
    descricao:
      'Acordos não pagos são quebrados automaticamente após os dias que você definir.',
  },
  {
    icon: <GavelIcon />,
    titulo: 'Negativação automática',
    descricao:
      'Envio automático para SPC/Serasa, sem depender de processo manual.',
  },
  {
    icon: <HubIcon />,
    titulo: 'Integração com credores',
    descricao:
      'Troque informações direto com os sistemas dos seus credores, sem retrabalho. ***',
  },
];

const DialogFuncionalidadesPro = ({ open, onClose }) => {
  const abrirWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=${WHATSAPP_COMERCIAL}&text=${encodeURIComponent(
        MENSAGEM_WHATSAPP
      )}`,
      '_blank'
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
      classes={{ paper: 'dialog-pro-paper' }}
    >
      <div className="dialog-pro">
        <div className="dialog-pro-header">
          <IconButton className="dialog-pro-close" onClick={onClose}>
            <CloseIcon />
          </IconButton>

          <div className="dialog-pro-badge">
            <WorkspacePremiumIcon />
          </div>

          <h2 className="dialog-pro-title">Plano PRÓ</h2>
          <p className="dialog-pro-subtitle">
            Tudo o que sua operação de cobrança ganha ao fazer um upgrade de
            plano
          </p>
        </div>

        <div className="dialog-pro-body">
          <div className="dialog-pro-section-label">
            Principais funções do Plano PRÓ
          </div>

          <div className="dialog-pro-grid">
            {FUNCIONALIDADES.map((item) => (
              <div className="dialog-pro-card" key={item.titulo}>
                <div className="dialog-pro-card-icon">{item.icon}</div>
                <div className="dialog-pro-card-text">
                  <span className="dialog-pro-card-title">{item.titulo}</span>
                  <span className="dialog-pro-card-desc">{item.descricao}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="dialog-pro-footer">
          <div className="dialog-pro-footer-text">
            <RocketLaunchIcon />
            <span>
              Fale com nosso time e libere essas funcionalidades na sua conta.
            </span>
          </div>

          <div className="dialog-pro-footer-actions">
            <Button className="dialog-pro-btn-secondary" onClick={onClose}>
              Agora não
            </Button>
            <Button
              className="dialog-pro-btn-primary"
              startIcon={<WhatsAppIcon />}
              onClick={abrirWhatsApp}
            >
              Quero migrar para o PRÓ
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

DialogFuncionalidadesPro.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DialogFuncionalidadesPro;
